import { useContext } from "react";
import CruzIcon from "../../../assets/images/generico/CruzIcon";
import CruzBlancaIcon from "../../../assets/images/generico/CruzBlancaIcon";
import { hideModal } from "../../../context/Actions/modal/modal";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { PortalContext } from "../../../context/Provider";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./KinesioCancelModal.css";

const KinesioCancelModal = ({ titulo, modalCancelar }) => {
  const { textosState, segundoModalDispatch } = useContext(PortalContext);

  const closeModal = () => {
    hideSegundoModal()(segundoModalDispatch);
  };
  return (
      <>
      <HeaderModal titulo={titulo} dissmiss={closeModal} />
      <div className="ptur-kinesiCancelModal123-container">
        {/* --------------HEADER---------------------- */}
        {/* <div className="ptur-kinesiCancelMolda123-header bgcG-latex30 ">
        <h1 className="ptur-kinesiCancelMolda123-header-title rb18m">
          Información
        </h1>
        <div
          className="ptur-kinesiCancelMolda1213-header-cruz"
          onClick={closeModal}
        >
         <CruzIcon />
        </div>
      </div> */}
        {/* --------------BODY---------------------- */}
        <div className="ptur-kinesiCancelMolda123-body rb18l">
          <p>
            {textosState.textos.loading
              ? "Loading..."
              : textosState.textos.data.msjCancelacionKIN.descripcion}
          </p>
        </div>
        <div className="ptur-kinesiCancelMolda123-btnCont">
          <button
            className="ptur-kinesiCancelMolda123-btnVolver rb16m bgc-white c-latex30"
            onClick={closeModal}
          >
            Volver
          </button>
          <button className="rb16m bgc-latex10 c-white" onClick={modalCancelar}>
            Continuar
          </button>
        </div>
      </div>
    </>
  );
};
export default KinesioCancelModal;
